module.exports = __webpack_public_path__ + "1b25931961e158780fa0c8ab375af9e0.svg";